import { useState } from "react";

export interface MainSwitchProps {
  onSwitch?: (tab: string) => void;
}

export default function ViewMgtDeviceMainSwitch({ onSwitch }: MainSwitchProps) {
  
  const [tabs] = useState(["Status", "Commands", "Configuration"]);
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const handleSwitch = (tab: string) => {
    setActiveTab(tab);
    onSwitch?.(tab);
  };

  return (
    <div className="flex justify-center my-4">
      <div className="inline-flex rounded-lg border border-gray-300 bg-gray-200 max-w-md w-full">
        {tabs.map((tab, index) => (
          <button key={tab} style={activeTab === tab ? { color: "#337BBB" } : {}} onClick={() => handleSwitch(tab)} className={`w-1/3 px-4 py-2 font-medium flex items-center justify-center gap-2 focus:outline-none font-bold ${activeTab === tab ? "bg-white shadow" : "text-gray-600"} ${index === 0 ? "rounded-l-lg" : ""} ${index !== 0 ? "border-l border-gray-300" : ""} ${index === tabs.length - 1 ? "rounded-r-lg" : ""}`}>
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
}